import ComingSoon from './ComingSoon';
import { Search } from 'lucide-react';

const SearchInterface = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ComingSoon
        title="Search"
        description="Advanced document search with semantic understanding and filtering capabilities will be available soon."
        icon={<Search className="h-8 w-8 text-blue-600" />}
      />
    </div>
  );
};

export default SearchInterface;
